import I18n from 'I18n';
import { StepIndicator } from 'foundations-components/transitional/components/StepIndicator';
import { useShareViaSettings } from './ShareViaSettingsContext';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
const ShareViaStepIndicator = () => {
  const {
    stepIndex
  } = useShareViaSettings();
  return /*#__PURE__*/_jsx(TFlex, {
    paddingBlockEnd: "1000",
    children: /*#__PURE__*/_jsx(StepIndicator, {
      direction: "horizontal",
      stepIndex: stepIndex,
      stepNames: [I18n.text('reporting-action-components.actions.shareVia.dialog.steps.sharingMethodStep.name'), I18n.text('reporting-action-components.actions.shareVia.dialog.steps.configurationStep.name')]
    })
  });
};
export default ShareViaStepIndicator;